import type { SupportedCurrency } from '@plevits/types';

export interface CurrencyConfig {
  code: SupportedCurrency;
  symbol: string;
  locale: string;
  monthly: number;
  annual: number;
  enterpriseFrom: number;
}

export const SUPPORTED_CURRENCIES: Record<SupportedCurrency, CurrencyConfig> = {
  GBP: { code: 'GBP', symbol: '\u00A3', locale: 'en-GB', monthly: 29, annual: 290, enterpriseFrom: 249 },
  USD: { code: 'USD', symbol: '$', locale: 'en-US', monthly: 39, annual: 390, enterpriseFrom: 299 },
  EUR: { code: 'EUR', symbol: '\u20AC', locale: 'de-DE', monthly: 35, annual: 350, enterpriseFrom: 279 },
};

export const COUNTRY_CURRENCY_MAP: Record<string, SupportedCurrency> = {
  US: 'USD',
  GB: 'GBP',
  DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR',
  AT: 'EUR', FI: 'EUR', IE: 'EUR', PT: 'EUR', GR: 'EUR', LU: 'EUR',
  SK: 'EUR', SI: 'EUR', LT: 'EUR', LV: 'EUR', EE: 'EUR', CY: 'EUR',
  MT: 'EUR', HR: 'EUR',
};

export const DEFAULT_CURRENCY: SupportedCurrency = 'USD';

export const VALID_CURRENCIES: SupportedCurrency[] = ['GBP', 'USD', 'EUR'];
